import notificationClient from '../../api/notificationClient';
import { Logs_Url, Log_Url, Log_Retry_Url } from '../../api/endpoints';
import type { BackendLogsResponse, BackendNotificationLog } from '../../schema/notification';

export interface LogFilters {
  sourceModule?: string;
  status?: string;
  channel?: string;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}

export const getLogs = async (filters?: LogFilters): Promise<BackendLogsResponse> => {
  const params = new URLSearchParams();
  if (filters?.sourceModule) params.set('sourceModule', filters.sourceModule);
  if (filters?.status) params.set('status', filters.status);
  if (filters?.channel) params.set('channel', filters.channel);
  if (filters?.search) params.set('search', filters.search);
  if (filters?.dateFrom) params.set('dateFrom', filters.dateFrom);
  if (filters?.dateTo) params.set('dateTo', filters.dateTo);
  if (filters?.page) params.set('page', String(filters.page));
  if (filters?.limit) params.set('limit', String(filters.limit));
  const { data } = await notificationClient.get<BackendLogsResponse>(`${Logs_Url}?${params}`);
  return data;
};

export const getLog = async (id: string): Promise<BackendNotificationLog> => {
  const { data } = await notificationClient.get<BackendNotificationLog>(Log_Url(id));
  return data;
};

/** POST /logs/:id/retry — currently returns 501 on the backend (preserved). */
export const retryLog = async (id: string): Promise<void> => {
  await notificationClient.post(Log_Retry_Url(id));
};
